"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImage = void 0;
const createImage = (source) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', error => reject(error));
        image.src = (source instanceof Blob) ? URL.createObjectURL(source) : source;
    });
};
exports.createImage = createImage;
